import { defineMessages } from 'react-intl';

/** The Account tab (design settings-redesign b1-b7). */
export const accountMessages = defineMessages({
  subtitle: {
    id: 'app.sml.settings.account.subtitle',
    defaultMessage: 'How you sign in, who you are on MUSIC24, and the way out.',
  },
  signInTitle: { id: 'app.sml.settings.account.signIn.title', defaultMessage: 'Sign-in' },
  signInDescription: {
    id: 'app.sml.settings.account.signIn.description',
    defaultMessage: 'We email a 6-digit code to this address each time you sign in.',
  },
  addressNote: {
    id: 'app.sml.settings.account.signIn.addressNote',
    defaultMessage: 'Also your billing and report address.',
  },
  stepNewEmail: {
    id: 'app.sml.settings.account.step.newEmail',
    defaultMessage: 'Step 1 of 2. Enter the new address. We send a code to it.',
  },
  stepCode: {
    id: 'app.sml.settings.account.step.code',
    defaultMessage: 'Step 2 of 2. We sent a 6-digit code to {email}. Your address changes when you confirm it.',
  },
  emailChangedNow: {
    id: 'app.sml.settings.account.emailChangedNow',
    defaultMessage: 'Your email is now {email}. Use it the next time you sign in.',
  },
  signOutTitle: { id: 'app.sml.settings.account.signOut.title', defaultMessage: 'Sign out' },
  signOutDescription: {
    id: 'app.sml.settings.account.signOut.description',
    defaultMessage: 'Signs you out on every device. API tokens and connected apps keep working. Manage them in API.',
  },
  deleteTitle: { id: 'app.sml.settings.account.delete.title', defaultMessage: 'Delete account' },
  deleteDescription: {
    id: 'app.sml.settings.account.delete.description',
    defaultMessage:
      'Removes your sign-in and your workspace {workspace} with its artists, pages, campaigns and reels. Your team members lose access to it.',
  },
  deleteHelp: { id: 'app.sml.settings.account.delete.help', defaultMessage: 'What deletion removes' },
  confirmTitle: { id: 'app.sml.settings.account.delete.confirm.title', defaultMessage: 'Delete your account?' },
  confirmIntro: {
    id: 'app.sml.settings.account.delete.confirm.intro',
    defaultMessage: 'This cannot be undone. We delete:',
  },
  confirmSignIn: {
    id: 'app.sml.settings.account.delete.confirm.signIn',
    defaultMessage: 'Your sign-in, {email}.',
  },
  confirmWorkspace: {
    id: 'app.sml.settings.account.delete.confirm.workspace',
    defaultMessage:
      'Your workspace {workspace}: its artists, SmartLinks and pre-save pages, campaigns, posts and reels.',
  },
  confirmTeam: {
    id: 'app.sml.settings.account.delete.confirm.team',
    defaultMessage: 'Access for your team members to this workspace. Their own workspaces stay.',
  },
  confirmCta: { id: 'app.sml.settings.account.delete.confirm.cta', defaultMessage: 'Delete account' },
});
